var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',{key:column.name},[_vm._v("\n                    "+_vm._s(column.label)+"\n                ")])}),0)]),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }